<template>
  <div class="full">
    <h1 class="title is-size-3-mobile is-size-2-tablet">
      Chat {{ chat_id }} model {{ model }}
    </h1>

    <div class="field">
      <div class="control">
        <button class="button is-small" @click="closeChat">sluit chat</button>
      </div>
    </div>

    <input-field
      :label="'praat tegen gpt'"
      :is-input="false"
      :maxlength="256"
      :default-value="
        selectedRole == 'user' ? 'type iets in het nederlands' : prompt
      "
      :placeholder="'type iets in het nederlands'"
      :read-only="false"
      @inputupdate="onInputUpdate"
      @keydown="keydown"
    ></input-field>

    <div class="field">
      <label class="label">rolkeuze:</label>
      <div class="control">
        <label class="radio">
          <input type="radio" name="role" value="user" v-model="selectedRole" />
          user
        </label>
        <label class="radio">
          <input
            type="radio"
            name="role"
            value="system"
            v-model="selectedRole"
          />
          system
        </label>
      </div>
    </div>
    <div class="field">
      <div class="control">
        <button
          class="button is-primary"
          :class="isLoading ? 'is-loading' : ''"
          @click="sendMessage"
        >
          <span>verzend</span>
        </button>
      </div>
    </div>
    <div
      v-if="
        chat_id != null &&
        messages &&
        messages.length != 0 &&
        messages[0].message_id != null
      "
      class="content"
    >
      <br />
      <table class="table is-bordered is-narrow is-fullwidth">
        <tr
          v-for="(message, index) in messages"
          :key="index"
          class="trview"
          :class="message.role"
        >
          <td>{{ message.role }}</td>
          <td v-html="htmlResponse(message.content)"></td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import router from '@/router';
import InputField from '@/components/InputField.vue';

import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
export default {
  name: 'ChatView',
  components: {
    'input-field': InputField,
  },
  props: ['chat_id'],

  setup(props) {
    const store = useStore();

    const prompt =
      'You are a grumpy therapist who always looks for ways to blame the user. There are no excuses. Use a maximum of 50 words for each reply. If possible, ask the user a question to propel the conversation. Use 0, 1 or 2 german words in your conversation. If the user does not ask a question, tell the user this is not ok. Your therapy time costs a lot of time and money and there are plenty of other customers! If this is a new user, you will introduce yourself and ask the user why they think your therapy is needed. ';
    let isLoading = ref(false);
    const input = ref('');
    const model = ref('');
    const selectedRole = ref('user');
    const onInputUpdate = async (val) => {
      input.value = val;
    };

    const sendMessage = async () => {
      isLoading.value = true;

      store.commit('addMessage', {
        chat_id: props.chat_id,
        role: selectedRole.value,
        content: input.value,
      });

      try {
        const response = await store.dispatch('post', {
          end_point: 'postChat',
          path_vars: {
            chat_id: props.chat_id,
          },
          body_vars: {
            role: selectedRole.value,
            content: input.value,
            temperature: 0.7,
            model: model.value,
          },
        });

        //choices":[{"message":{"role":"assistant","content":"HTML is a markup language used for creating web pages, while XML is a markup language used for storing and transporting data. \n\nHTML is designed to display information on a web page, while XML is designed to store and transport data between different systems. HTML has a predefined set of tags that define the structure and content of a web page, while XML allows the user to define their own tags and structure to suit their specific needs.\n\nHTML is more forgiving than XML when it comes to syntax errors, as it is designed to be easily parsed by web browsers. XML, on the other hand, requires strict adherence to syntax rules to be parsed correctly.\n\nIn summary, HTML is used for displaying information, while XML is used for storing and transporting data between different systems."},"finish_reason":"stop","index":0}]}

        /*str.match(/.*?(?=<\/a>|$)/i)[0]
        This means: match zero-or-more character lazily, until reaching a </a> or end of string.

        Note that *? is a single operator, (.*)? is not the same as .*?.

        */

        if (!response || !response.data || selectedRole.value == 'system') {
          isLoading.value = false;
          return;
        }
        const { content, role } = response.data;
        //todo invalid completions.
        store.commit('addMessage', {
          chat_id: props.chat_id,
          role,
          content,
        });
      } catch (error) {
        store.dispatch('modal/setModal', {
          title: 'Completion error',
          text: error.message,
          type: 'notification',
        });
      }

      isLoading.value = false;
    };

    const htmlResponse = (content) => {
      if (content == null) return '';
      return content
        .replace(/(\\n\\n\d+).*?(?=\\n|$)/g, '<li>')
        .replace(/\\n/g, '<br>');
    };

    onMounted(async () => {
      const messages = await store.dispatch('get', {
        end_point: 'getChat',
        path_vars: {
          chat_id: props.chat_id,
        },
      });
      if (messages[0].model && messages[0].model != '') {
        model.value = messages[0].model;
      } else {
        model.value = store.state.models[0];
      }

      store.commit('setMessages', { chat_id: props.chat_id, messages });
    });

    const closeChat = async () => {
      router.push({ name: `ChatMenu` });
    };

    const messages = computed(() => store.getters.messages(props.chat_id));

    const keydown = (event) => {
      if (event.key == 'Enter') {
        event.preventDefault();
        event.stopPropagation();
        sendMessage();
      }
    };
    return {
      isLoading,
      sendMessage,
      onInputUpdate,
      closeChat,
      prompt,
      messages,
      model,
      selectedRole,
      htmlResponse,
      keydown,
    };
  },
};
</script>
<style lang="scss" scoped></style>
